import React, { useEffect, useState } from 'react';

const PromoPopup = ({ alwaysShow = false }) => {
  // Popup visibility is in-memory only so it reappears after refresh
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    // Listen for cross-component close events in the same tab
    const onClose = () => setShowPopup(false);
    window.addEventListener('promo-popup-closed', onClose);
    return () => window.removeEventListener('promo-popup-closed', onClose);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
    // notify other mounted instances in same page
    window.dispatchEvent(new Event('promo-popup-closed'));
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl shadow-2xl w-11/12 max-w-xl max-h-screen overflow-y-auto p-6 flex flex-col items-center">
        {/* Header */}
        <h2 className="text-2xl md:text-3xl font-extrabold text-custom-misty-red mb-4 text-center">
          Early Bird Promotion Now Open!
        </h2>

        {/* Large Image (centered) */}
        <img
          src={`${process.env.PUBLIC_URL}/Photos/Screenshot_promo.png`}
          alt="Promotion"
          className="w-full max-w-3xl rounded-lg shadow-md object-contain mb-4"
        />

        {/* Close Button (below image) */}
        <button
          onClick={handleClose}
          className="mt-2 bg-custom-blue text-white px-8 py-3 rounded-lg font-semibold text-lg hover:bg-blue-700 transition duration-300 shadow-md"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PromoPopup;